import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import history from '../../helpers/history';

import { Layout, PageHeader, Button, Input, Form, Modal, Divider, Spin, message, DatePicker, Radio, Checkbox, Select } from 'antd';
import moment, { max } from 'moment';

import PortfolioResult from './PortfolioResult';

import TooltipPage from '../../pannels/account/TooltipPage';
import emitter from '../Evt.js';

const { Content } = Layout;
const Option = Select.Option;
const RadioGroup = Radio.Group;

var languageMessages = window.appLocale.messages;

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

const SelectWidth = 80;

const locale = window.appLocale.locale;
class PortfolioPage extends Component {
    constructor(props) {
        super(props);

        this.customGroupsData = [];

        this.user = {};
        this.state = {
            stockPoolKey: 'CUSTOM_GROUPS',

            customGroups: '-',

            barinterval: 'D',
            tradePeriod: false,
            tradePeriodValue: '',
            tradePeriodUnit: 'M',

            lastTimes: 0,

            startDate: moment().add(-90, 'days').format('YYYY-MM-DD'),
            endDate: moment().add(-1, 'days').format('YYYY-MM-DD'),

            endOpen: false,

            tradeDateStatus: '',
            tradeDateMessage: '',

            backtestStatus: 0,
            statisticsResult: {},

            isStartPortfolio: false,

            portfolioState: false,

            spinLoadding: true,

            filterError: '',
        };
    }

    componentDidMount() {
        emitter.addListener('initPage', this.init);

        emitter.addListener('callPortfolioOptStatus', this.callPortfolioOptStatus);
        emitter.addListener("callPortfolioOptError", this.callPortfolioOptError);
        emitter.addListener('callPortfolioOptLastTimes', this.callPortfolioOptLastTimes);
        emitter.addListener('callPortfolioOptResult', this.callPortfolioOptResult);
        
    }

    callPortfolioOptError = (status) => {
        //message.error('portfolio opt , Error:' + status);
        this.setState({ backtestStatus: 0, portfolioState: false, filterError: strReplace(languageMessages['portfolioError'], { '{errorCode}': status }) });
    }

    callPortfolioOptStatus = (status) => {
        /**
         * if (status == 1) {
            message.success('portfolio success');
        } else {
            message.error('portfolio fail');
        }
         */ 

        this.setState({ backtestStatus: 1 });
    }

    callPortfolioOptLastTimes = (lastTimes, permission) => {
        if (this.user.permission !== undefined) {
            this.user.permission = permission;
            sessionStorage.setItem("auth", JSON.stringify(this.user));
        }

        this.setState({ lastTimes, backtestStatus: 2 });
    }

    callPortfolioOptResult = (result) => {
        var statisticsResult = result;

        this.setState({ statisticsResult, portfolioState: false, backtestStatus: 3 });
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        emitter.removeListener('initPage', this.init);

        emitter.removeListener('callPortfolioOptStatus', this.callPortfolioOptStatus);
        emitter.removeListener('callPortfolioOptError', this.callPortfolioOptError);
        emitter.removeListener('callPortfolioOptLastTimes', this.callPortfolioOptLastTimes);
        emitter.removeListener('callPortfolioOptResult', this.callPortfolioOptResult);
    }

    init = () => {
        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        /**
        if (user.username === undefined) {
            this.setState({ spinLoadding: false }, () => {
                this.props.dispatch({ type: "action_non_user" });
            });
        } else {
            this.props.dispatch({ type: "action_get_luis_sectors", payload: { UserId: user.username, stockPoolKey: this.state.stockPoolKey, stockGroups: this.state.stockGroups } });
        }
        */

        let { customGroups } = this.state;

        var customGroupsItems = JSON.parse(sessionStorage.getItem("CustomStockGroupsCache") || '[]') || [];
        if (customGroupsItems !== null) {
            //自定义自选股
            this.customGroupsData = [];
            if (customGroupsItems.length > 0) {
                for (let key in customGroupsItems) {
                    if (customGroups === '-') {
                        customGroups = customGroupsItems[key].groupId.toString();
                    }
                    this.customGroupsData.push(<Option key={customGroupsItems[key].groupId}>{customGroupsItems[key].groupName}</Option>);
                }
            }

            var isStartPortfolio = this.checkIsStartPortfolio('customGroup', customGroups);

            this.setState({ customGroups, isStartPortfolio });
        }

        this.props.dispatch({ type: "action_get_portfolio_info", payload: { UserId: this.user.username } });
    }

    setUserPermission(permissions) {
        var lastTimes = 0;
        for (var key in permissions) {
            var permission = permissions[key];
            switch (permission.type) {
                case 'p':
                    lastTimes += permission.totalCount - permission.usageCount;
                    break;
                default:
                    lastTimes += 0;
                    break;
            }
        }
        this.setState({ lastTimes });
    }

    componentWillReceiveProps(props) {
        var { status, state, permission, portfolioId } = props;

        switch (status) {
            case 'info_success':
                if (this.user.permission !== undefined) {
                    this.user.permission = permission;
                    sessionStorage.setItem("auth", JSON.stringify(this.user));
                    this.setUserPermission(this.user.permission);
                }

                this.setState({ spinLoadding: false });
                break;
            case 'info_fail':
                if (this.user.permission !== undefined) {
                    this.setUserPermission(this.user.permission);
                }
                var error = languageMessages['get.data.failed'];
                switch (state) {
                    case 0:
                        break;
                    case 2:
                        error = languageMessages['user.exception'];
                        break;
                    default:
                        break;
                }
                message.error(error);
                this.setState({ spinLoadding: false });
                break;
            case 'start_portfolio_success':
                console.log(portfolioId);
                break;
            case 'start_portfolio_fail':
                message.error('start portfolio fail');
                break;
            default:
                break;
        }
    }

    timerModal(title, content) {
        let secondsToGo = 5;
        const modal = Modal.success({
            title: title,
            content: content,
        });

        setTimeout(() => {
            modal.destroy();
        }, secondsToGo * 1000);
    }

    onMyPortfolio = e => {
        e.preventDefault();

        Modal.destroyAll();

        emitter.emit('callJump', 'mpo');
        history.push("/mpo");
    }

    checkIsStartPortfolio(type, value) {
        let { customGroups, startDate, endDate } = this.state;

        var isStartPortfolio = false;
        switch (type) {
            case 'startDate':
                startDate = value;
                break;
            case 'endDate':
                endDate = value;
                break;
            case 'customGroup':
                customGroups = value;
                break;
            default:
                break;
        }

        if (customGroups != '-' && customGroups != '') {

            var oDate1 = new Date(startDate);
            var oDate2 = new Date(endDate);

            if (oDate2.getTime() > oDate1.getTime()) {
                isStartPortfolio = true;
            }
        }

        return isStartPortfolio;
    }

    //开始日期
    onChangeStartDate = startDate => {
        startDate = moment(startDate).format("YYYY-MM-DD");

        //判断小于结束时间
        /** 
        var oDate1 = new Date(startDate);
        var oDate2 = new Date(endDate);
        if (oDate1.getTime() < oDate2.getTime()) {
            
        }
        */

        var isStartPortfolio = this.checkIsStartPortfolio('startDate', startDate);

        this.setState({ startDate, isStartPortfolio });
    }

    //结束日期
    onChangeEndDate = endDate => {
        endDate = moment(endDate).format("YYYY-MM-DD");

        var tradeDateStatus = '';
        var tradeDateMessage = '';

        var oDate1 = new Date(this.state.startDate);
        var oDate2 = new Date(endDate);

        var intDate1 = oDate1.getTime();
        var intDate2 = oDate2.getTime();
        if (intDate1 > intDate2) {
            tradeDateStatus = 'error';
            tradeDateMessage = languageMessages['startDateGreaterThanEndDate'];
        }

        var isStartPortfolio = this.checkIsStartPortfolio('endDate', endDate);

        this.setState({ endDate, isStartPortfolio, tradeDateStatus, tradeDateMessage });
    }

    todayDisabledDate = current => {
        const { endDate } = this.state;
        if (!endDate) {
            return false;
        }
        return current && (current > moment(endDate) || current < moment(endDate).add(-6, 'months'));
    }

    endDisabledDate = current => {
        const { startDate } = this.state;
        if (!startDate) {
            return false;
        }
        return current && (current < moment(startDate) || current > moment().add(-1, 'days'));
    }

    handleStartOpenChange = open => {
        if (!open) {
            this.setState({ endOpen: true });
        }
    };

    handleEndOpenChange = endOpen => {
        var tradeDateStatus = '';
        var tradeDateMessage = '';

        if (!endOpen) {
            //判断日期是否小于开始日期
            var oDate1 = new Date(this.state.startDate);
            var oDate2 = new Date(this.state.endDate);

            var intDate1 = oDate1.getTime();
            var intDate2 = oDate2.getTime();
            if (intDate1 > intDate2) {
                tradeDateStatus = 'error';
                tradeDateMessage = languageMessages['startDateGreaterThanEndDate'];
            }
        }

        this.setState({ endOpen, tradeDateStatus, tradeDateMessage });
    };

    handleCustomGroupsChange = value => {
        var isStartPortfolio = this.checkIsStartPortfolio('customGroup', value.key);

        this.setState({
            customGroups: value.key,
            isStartPortfolio
        });
    }

    onSelectBarInterval = e => {
        var barinterval = e.target.value;
        this.setState({ barinterval });
    }

    handleChangeTradePeriod = e => {
        var tradePeriod = e.target.checked;

        this.setState({ tradePeriod });
    }

    handleNumberChange = e => {
        var number = e.target.value;
        this.setState({ tradePeriodValue: number });
    }

    onBlurNumberChange = e => {
        e.preventDefault();

        var number = e.target.value;

        this.setState({ tradePeriodValue: number });
    }

    handleTradePeriodUnitChange = value => {

        this.setState({
            tradePeriodUnit: value.key,
        });
    }

    onValueAddedServices = e => {
        e.preventDefault();
        Modal.destroyAll();

        history.push({ pathname: '/member', state: { memberMenuSelectKey: "2" } });
    }

    onStartPortfolio = () => {
        let { lastTimes, startDate, endDate, stockPoolKey, customGroups, barinterval, tradePeriod, tradePeriodValue, tradePeriodUnit } = this.state;

        window._hmt && window._hmt.push(['_trackEvent', 'Portfolio', 'Portfolio', 'Portfolio Stock']);

        if (this.user.username === undefined) {
            //saved to cache

            this.props.dispatch({ type: "action_non_user" });
        } else {
            if (lastTimes <= 0) {
                var content = <span>{languageMessages['today.stock.picks.end']}，{languageMessages['please go']}<a onClick={this.onValueAddedServices}>{languageMessages['value-added.services']}</a></span>;
                Modal.info({
                    title: languageMessages['prompt'],
                    content: content
                });
                return;
            }
            
            var tmpTradePeriod = '';
            if (tradePeriod) {
                tmpTradePeriod = tradePeriodValue + ',' + tradePeriodUnit;
            }

            this.setState({
                backtestStatus: 0,
                statisticsResult: [],
                portfolioState: true,
                filterError: '',
            }, () => {
                this.props.dispatch({
                    type: "action_send_hub_message", payload: {
                        service: 'startPortfolio', userId: this.user.username,
                        msg: {
                            /**
                             * FormDate: startDate,
                            ToDate: endDate,
                            SymbolGroupType: stockPoolKey,
                            CustomSymbolGroupId: customGroups,
                            Barinterval: barinterval,
                            TradePeriod: tmpTradePeriod
                             */
                            Type: 'porrtfolioBacktest',
                            f: startDate,
                            t: endDate,
                            sgt: stockPoolKey,
                            csg: customGroups,
                            bi: barinterval,
                            tp: tmpTradePeriod
                        }
                    }
                });
            });

            /**
            this.props.dispatch({
                type: "action_start_portfolio", payload: {
                    u: this.user.username,
                    f: startDate,
                    t: endDate,
                    sgt: stockPoolKey,
                    csg: customGroups,
                    bi: barinterval,
                    tp: tmpTradePeriod
                }
            });
            */
        }
    };

    render() {
        var { barinterval } = this.state;

        return (<Content className='main-container total-content'>
            <Helmet>
                <title>{languageMessages['title']}</title>
                <meta name="keywords" content={languageMessages['keywords']} />
                <meta name="description" content={languageMessages['description']} />

                <meta property="og:title" content={languageMessages['title']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['description']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['title']} />
                <meta name="twitter:description" content={languageMessages['description']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
            <Spin spinning={this.state.spinLoadding}>
                <div className='common-page-header'>
                    <PageHeader title={(<h1>{'Portfolio'}</h1>)}
                        extra={[
                            <Button key="1" size='small' onClick={this.onMyPortfolio}>{languageMessages['my.portfolio']}</Button>
                        ]} />
                </div>
                <div style={{ padding: '0px 50px', marginBottom: '20px' }}>
                    <div className='common-title'><Divider type="vertical" />{languageMessages['basic.info']}</div>
                    <div className='common-backtest-cont'>
                        <label>{languageMessages['optional.stock.pool']}</label>
                        <Select labelInValue size='small'
                            defaultValue={{ key: this.state.customGroups }}
                            style={{ width: 180, padding: '0 10px' }}
                            onChange={this.handleCustomGroupsChange}>
                            {this.customGroupsData}
                        </Select>
                    </div>
                    <div className='common-title'><Divider type="vertical" />{languageMessages['backtestCondition']}</div>
                    <div className='common-backtest-cont'>
                        <div style={{ marginBottom: '20px' }}>
                            <Form labelAlign={'left'} layout="inline" className={window.webType === 'US' ? 'common-form-hawkeye hawkeye-us' : 'common-form-hawkeye'}>
                                <Form.Item colon={false} label={languageMessages['backtestInterval']} validateStatus={this.state.tradeDateStatus} help={this.state.tradeDateMessage}>
                                    <span style={{ display: 'inline-block' }}>
                                        <DatePicker size="small"
                                            allowClear={false}
                                            placeholder={languageMessages['pleaseEnterStartDate']}
                                            value={moment(this.state.startDate, "YYYY-MM-DD")}
                                            disabledDate={this.todayDisabledDate}
                                            format={"YYYY-MM-DD"} style={{ width: '120px' }}
                                            onChange={this.onChangeStartDate}
                                            onOpenChange={this.handleStartOpenChange}
                                        />
                                    </span>
                                    <span style={{ display: 'inline-block', width: '24px', textAlign: 'center' }}>{languageMessages['intl.to']}</span>
                                    <span style={{ display: 'inline-block' }}>
                                        <DatePicker size="small"
                                            allowClear={false}
                                            placeholder={languageMessages['pleaseEnterEndDate']}
                                            value={moment(this.state.endDate, "YYYY-MM-DD")}
                                            disabledDate={this.endDisabledDate}
                                            format={"YYYY-MM-DD"} style={{ width: '120px' }}
                                            onChange={this.onChangeEndDate}
                                            disabled={this.state.startDate === ''}
                                            open={this.state.endOpen}
                                            onOpenChange={this.handleEndOpenChange}
                                        />
                                    </span>
                                </Form.Item>
                            </Form>
                        </div>
                        <div style={{ marginBottom: '20px' }}>
                            <RadioGroup onChange={this.onSelectBarInterval} value={barinterval}>
                                <Radio value={'D'}>{languageMessages['Daily']}</Radio>
                                <Radio value={'60'}>{languageMessages['60Min']}</Radio>
                            </RadioGroup>
                        </div>
                        <div style={{ marginBottom: '20px' }}>
                            <Checkbox checked={this.state.tradePeriod} onChange={this.handleChangeTradePeriod}>{languageMessages['Whether to adjust the warehouse']}</Checkbox>
                        </div>
                        <div style={{ marginBottom: '20px', display: this.state.tradePeriod ? '' : 'none' }}>
                            <Input type="text" size='small' style={{ width: 80 }} value={this.state.tradePeriodValue} onChange={this.handleNumberChange} onBlur={this.onBlurNumberChange} placeholder={languageMessages['pleaseEnterGrids']} />
                            <span style={{ marginLeft: '10px' }}>
                                <Select labelInValue
                                    size='small'
                                    defaultValue={{ key: this.state.tradePeriodUnit }}
                                    dropdownMatchSelectWidth={false}
                                    style={{ minWidth: SelectWidth }}
                                    onChange={this.handleTradePeriodUnitChange}>
                                    <Option key='M'>{languageMessages['Month']}</Option>
                                    <Option key='W'>{languageMessages['Week']}</Option>
                                    <Option key='D'>{languageMessages['Daily']}</Option>
                                    <Option key='H'>{languageMessages['Hour']}</Option>
                                </Select>
                            </span>
                        </div>
                        <Button size='small' loading={this.state.portfolioState} disabled={!this.state.isStartPortfolio} onClick={this.onStartPortfolio}>
                            {languageMessages['startPortfolio']}
                        </Button>
                        <TooltipPage lastTimes={this.state.lastTimes} filterError={this.state.filterError} />
                    </div>
                </div>
                <div style={{ backgroundColor: '#efefef', height: '48px', lineHeight: '48px', padding: '0 50px', display: this.state.backtestStatus > 0 ? 'block' : 'none' }}>
                    <div style={{ float: 'left' }}>
                        <b>{languageMessages['status']}</b>
                        <span style={{ margin: '0 10px', display: this.state.backtestStatus == 1 ? 'inline-block' : 'none' }}>{languageMessages['queue']}</span>
                        <span style={{ display: this.state.backtestStatus == 2 ? 'inline-block' : 'none' }}>
                            <span style={{ margin: '0 10px' }}>{languageMessages['query prompt']}</span>
                        </span>
                        <span style={{ margin: '0 10px', display: this.state.backtestStatus == 3 ? 'inline-block' : 'none' }}>{Object.keys(this.state.statisticsResult).length > 0 ? languageMessages['queryingCompletedConsuming'] : languageMessages['No Portfolio optimization results']}</span>
                    </div>
                </div>
                <Content style={{ padding: '0px 50px', marginBottom: '50px' }}>
                    {Object.keys(this.state.statisticsResult).length == 0 || (<PortfolioResult dispatch={this.props.dispatch} status={this.props.status} statisticsResult={this.state.statisticsResult} />)}
                </Content>
            </Spin>
        </Content>);
    }
}

function mapStateToProps(state) {
    return state.portfolio;
}

const page = connect(mapStateToProps)(PortfolioPage);
export { page as default }